// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__osJ3B","spinner":"IpaAdministrationWizard_spinner__ERr-b"};